import { FC } from 'react'

const ShippingIconBorderless: FC = () => (
  <svg
    width="22"
    height="23"
    viewBox="0 0 22 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_42237_593904)">
      <path
        d="M14.6719 2.42188H0.921875V14.3385H14.6719V2.42188Z"
        stroke="#78A183"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6719 7.00781H18.3385L21.0885 9.75781V14.3411H14.6719V7.00781Z"
        stroke="#78A183"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.04167 18.9349C6.30732 18.9349 7.33333 17.9089 7.33333 16.6432C7.33333 15.3776 6.30732 14.3516 5.04167 14.3516C3.77601 14.3516 2.75 15.3776 2.75 16.6432C2.75 17.9089 3.77601 18.9349 5.04167 18.9349Z"
        stroke="#78A183"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9635 18.9349C18.2292 18.9349 19.2552 17.9089 19.2552 16.6432C19.2552 15.3776 18.2292 14.3516 16.9635 14.3516C15.6979 14.3516 14.6719 15.3776 14.6719 16.6432C14.6719 17.9089 15.6979 18.9349 16.9635 18.9349Z"
        stroke="#78A183"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_42237_593904">
        <rect
          width="22"
          height="22"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>

)

export default ShippingIconBorderless
